<template>
  <div class="menu-side">
    <div v-if="isPortraitOrderRoute" class="d-grid menu-order-tools">
      <toggle-router-link
        :toRouteName="'new-order'"
        :className="'btn btn-light'"
        :redirectCondition="shift != null && shift != false"
        :errorMessage="$gettext('Please start shift')"
        @click.native="closeMenuSide()"
        v-translate
      >New</toggle-router-link>
      <toggle-router-link
        :toRouteName="'change-order'"
        :className="'btn btn-light'"
        :redirectCondition="bill.staff !== ''"
        @click.native="closeMenuSide()"
        v-translate
      >Change Table/Room/Cover</toggle-router-link>
      <button
        v-if="isCashier"
        class="btn btn-light"
        @click="onVoid(); closeMenuSide()"
        v-translate
      >Void</button>
      <button
        v-if="isCashier"
        class="btn btn-light"
        @click="pusleDrawer(); closeMenuSide()"
        v-translate
      >Open Drawer</button>
      <toggle-router-link
        v-if="isCashier"
        :toRouteName="'split-bill'"
        :routeParams="{ bill: bill }"
        :className="'btn btn-light'"
        :redirectCondition="[isCashier, can('closeBill'), isBill('open')]"
        :errorMessage="[
          $gettext('Permission denied'),
          $gettext('Permission denied'),
          $gettext('Please get an open bill')
        ]"
        @click.native="closeMenuSide"
        v-translate
      >Split</toggle-router-link>
      <toggle-router-link
        v-if="isCashier"
        :toRouteName="'merge-bill'"
        :routeParams="{ bill: bill }"
        :className="'btn btn-light'"
        :redirectCondition="[isCashier, can('closeBill'), isBill('open')]"
        :errorMessage="[
          $gettext('Permission denied'),
          $gettext('Permission denied'),
          $gettext('Please get an open bill')
        ]"
        @click.native="closeMenuSide"
        v-translate
      >Merge</toggle-router-link>
      <button
        class="btn btn-light"
        @click="$store.dispatch('clearOrder'); closeMenuSide()"
        v-translate
      >Clear</button>
      <div class="menu-order-tools__lookup">
        <input-pad
          :item="orderAction"
          :property="'billId'"
          :maxLength="20"
          :attributes="{ 'class': 'form-control form-control-sm', 'placeholder': $gettext('Enter Bill ID'), 'inputmode': 'numeric' }"
        />
        <input-pad
          :item="orderAction"
          :property="'staffRef'"
          :alphabetable="true"
          :maxLength="20"
          :attributes="{ 'class': 'form-control form-control-sm', 'placeholder': $gettext('Enter Staff ID'), 'inputmode': 'text' }"
        />
        <button class="btn btn-light" @click="doAction" v-translate>OK</button>
      </div>
    </div>
    <div v-if="isCashier" class="d-grid">
      <router-link
        :to="{ name: 'staffs' }"
        class="btn btn-light"
        :event="''"
        @click.native="toggleStaffs(null); closeMenuSide()"
        v-translate
      >
        All Staffs
      </router-link>
      <div class="staff-out-in">
        <router-link
          :to="{ path: '/staffs-out' }"
          class="btn btn-light"
          :event="''"
          @click.native="toggleStaffs(false); closeMenuSide()"
          v-translate
        >
          Out
        </router-link>
        <router-link
          :to="{ path: '/staffs-in' }"
          class="btn btn-light"
          :event="''"
          @click.native="toggleStaffs(true); closeMenuSide()"
          v-translate
        >
          In
        </router-link>
      </div>
    </div>
    <div class="d-grid">
      <toggle-router-link
        v-if="isCashier"
        :toRouteName="'pay-commission'"
        :className="'btn btn-light'"
        :redirectCondition="[isCashier, can('payCommission')]"
        :errorMessage="[$gettext('Permission denied')]"
        @click.native="closeMenuSide"
        v-translate
      >
        Pay Comm.
      </toggle-router-link>
      <toggle-router-link
        v-if="isCashier"
        :toRouteName="'stock-delivery'"
        :className="'btn btn-light'"
        :redirectCondition="[isCashier, can('updateStock')]"
        :errorMessage="[$gettext('Permission denied')]"
        @click.native="closeMenuSide"
        v-translate
      >
        Stock Delivery
      </toggle-router-link>
      <toggle-router-link
        v-if="isCashier"
        :toRouteName="'do-payment'"
        :className="'btn btn-light'"
        :redirectCondition="[isCashier, can('addPayment'), shift]"
        :errorMessage="[
          $gettext('Permission denied'),
          $gettext('Permission denied'),
          $gettext('Please start shift'),
        ]"
        @click.native="closeMenuSide"
        v-translate
      >
        Do payment
      </toggle-router-link>
      <toggle-router-link
        v-if="isCashier"
        :toRouteName="'add-staff'"
        :className="'btn btn-light'"
        :redirectCondition="[isCashier, can('addCustomer'), !user.location.useLocalServer]"
        :errorMessage="[$gettext('Permission denied')]"
        :disabled="user.location.useLocalServer"
        @click.native="closeMenuSide"
        v-translate
      >
        Add staff
      </toggle-router-link>
      <toggle-router-link
        :toRouteName="'bills-reprint'"
        :className="'btn btn-light'"
        @click.native="closeMenuSide"
        v-translate
      >
        Reprint bill
      </toggle-router-link>
      <button
        v-if="isCashier"
        class="btn btn-light"
        @click="printArticleLocation"
        v-translate
      >
        Print Articles
      </button>

      <button
        v-show="shift && isCashier"
        class="btn btn-light"
        @click="endShift"
        v-translate
      >
        End of shift
      </button>
      <button
        v-show="!shift && canManageShiftStart"
        class="btn btn-light"
        @click="startShift"
        v-translate
      >
        Start of shift
      </button>
      <button
        v-show="workDay && canManageCashierFlow"
        class="btn btn-light"
        @click="endDay"
        v-translate
      >
        End of day
      </button>
      <button
        v-show="!workDay && canManageCashierFlow"
        class="btn btn-light"
        @click="confirmStartDay"
        v-translate
      >
        Start of day
      </button>
      <button
        type="button"
        class="btn btn-light"
        @click="closeMenuSide(); $store.dispatch('logout')"
        v-translate
      >
        Log out
      </button>
      <toggle-router-link
        v-if="canManageCashierFlow"
        :toRouteName="'cash-calc'"
        :className="'btn btn-light'"
        :redirectCondition="[canManageCashierFlow]"
        :errorMessage="[$gettext('Permission denied')]"
        @click.native="resetCurrentShift(); closeMenuSide()"
        v-translate
      >
        Cash Calc
      </toggle-router-link>
    </div>
    <portal to="bodyModalOption">
      <modal-option
        v-show="isModalPrintArticleVisible"
        @cancelModalOption="cancelModalPrintArticle"
        :options="printArticleOptions"
        :message="printArticleMessage"
        @callback = "optionSelected"
      />
    </portal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import DayService from "@/services/DayService";
import ToggleRouterLink from "@/components/ToggleRouterLink.vue";
import InputPad from "@/components/InputPad.vue";
import { Portal, PortalTarget, MountingPortal } from "portal-vue";
import ShiftService from "@/services/ShiftService";

import {
  SET_SHIFT_CURRENT_ACTION,
  //START_DAY,
  TOGGLE_MENU_SIDE,
  SET_MESSAGE_MODAL,
  SET_CONFIRM_MODAL,
  ON_INPUT_PAD_BLUR,
} from "@/store/mutation-types";
import ArticleService from "../services/ArticleService";
import ModalOption from "./ModalOption.vue";
export default {
  name: "MenuSide",
  props: {
    orderAction: {
      type: Object,
      default: () => ({
        staffRef: '',
        billId: '',
      }),
    },
    orderActionHandler: {
      type: Function,
      default: null,
    },
  },
  components: {
    ToggleRouterLink,
    InputPad,
    ModalOption,
    Portal,
    PortalTarget,
    MountingPortal,
  },
  data() {
    return {
      isModalPrintArticleVisible: false,
      messagePrintArticle:
        "Please select if the report should be printed from the location or this station",

    };
  },
  computed: {
    ...mapState({
      workDay: (state) => state.auth.user.workDay,
      shift: (state) => state.auth.user.shift,
      user: (state) => state.auth.user,
      bill: (state) => state.bill.bill,
    }),
    ...mapGetters([
      'isBill',
    ]),
    isPortraitOrderRoute() {
      return typeof document !== 'undefined'
        && document.body.classList.contains('portrait-mode')
        && this.$route.name === 'order';
    },
    printArticleMessage() {
      return this.$gettext("Print for " + this.user.station.name + " or all");
    },
    printArticleOptions() {
      return [
        {
          label: this.user.station.name,
          emitEvent: "cashierSelected",
        },
        {
          label: "All",
          emitEvent: "locationSelected",
        },
      ];
    },
  },
watch: {
  workDay(newVal) {
    console.log('MenuSide.vue: workDay changed:', newVal);
  }
},
  methods: {
    async pusleDrawer() {
      if (!this.isCashier) {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Permission denied'));
        return;
      }
      const data = await ShiftService.pusleDrawer();
      if (data && !data.error) {
        await this.$store.dispatch('print', data);
      } else {
        this.$store.commit(SET_MESSAGE_MODAL, data);
      }
    },
    onVoid() {
      if (!this.isCashier) {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Permission denied'));
        return;
      }
      if (this.$store.getters.isBill('open')) {
        this.$store.commit(SET_CONFIRM_MODAL, {
          action: this.$gettext('void bill'),
          context: this,
          func: () => {
            this.$router.push({ name: 'void-bill' });
            this.$store.commit(SET_CONFIRM_MODAL, null);
          },
        });
      } else {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Please get an open bill'));
      }
    },
    async doAction() {
      if (this.orderActionHandler) {
        const success = await this.orderActionHandler();
        if (success) {
          this.closeMenuSide();
        }
        return;
      }
      this.$emit('do-order-action');
    },
    async optionSelected(event)  {
      if (!this.isCashier) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Permission denied")
        );
        return;
      }
      this.isModalPrintArticleVisible = false;
      let useLocation = (event == 'cashierSelected');
      const data = await ArticleService.printReportArticles(useLocation);
      if (data && !data.error) {
        await this.$store.dispatch("print", data);
      } else {
        this.$store.commit(SET_MESSAGE_MODAL, data);
      }
    },
    showModal() {
      this.isModalPrintArticleVisible = true;
    },
    cancelModalPrintArticle() {
      console.log("cancelModalPrintArticle");
      this.isModalPrintArticleVisible = false;
    },
    closeModalPrintArticle() {
      this.isModalPrintArticleVisible = false;
    },
    closeMenuSide() {
      this.$store.commit(ON_INPUT_PAD_BLUR, true);
      this.$store.commit(TOGGLE_MENU_SIDE, false);
    },
    resetCurrentShift() {
      if (!this.canManageCashierFlow) {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext("Permission denied"));
        return;
      }
      this.$store.commit(SET_SHIFT_CURRENT_ACTION, null);
    },
    toggleStaffs(status) {
      if (!this.isCashier) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Permission denied")
        );
      } else if (!this.shift) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Please start shift")
        );
      } else {
        let url = "/staffs";
        if (status === true) {
          url += "-in";
        } else if (status === false) {
          url += "-out";
        }

        if (this.$router.currentRoute.path === url) {
          return this.$router.push({ name: "order" });
        }
        this.$store.state.staff.staffPage = status;
        return this.$router.push({ path: url });
      }
    },
    confirmStartDay() {
      if (!this.canManageCashierFlow) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Only cashiers (logged in with a cashier role) can start work days")
        );
        return;
      }
      this.$store.commit(SET_CONFIRM_MODAL, {
        action: this.$gettext("start a work day"),
        context: this,
        func: this.startDay,
      });
    },
    async startDay() {
      try {
      await this.$store.dispatch('startDay');
      } catch (error) {
        console.log(error);
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Unable to start work day. Please try again or contact your manager. error is " + error.message)
        );
        return;
      }
      // Optionally close the modal here if needed
      return true;
    },
    async endDay() {
      if (!this.canManageCashierFlow) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Only cashiers (logged in with a cashier role) can end work days")
        );
        return;
      }
      const response = await DayService.checkShift();
      if (response && response.result) {
        this.$router.push({ name: "end-of-day" });
      }
    },
    startShift() {
      if (!this.canManageShiftStart) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Permission denied")
        );
        return;
      }
      if (!this.workDay) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Please start day")
        );
        return;
      }
      this.$store.commit(SET_SHIFT_CURRENT_ACTION, "start");
      this.closeMenuSide();
      if (this.$route.name !== "cash-calc") {
        this.$router.push({ name: "cash-calc" });
      }
    },
    endShift() {
      if (!this.isCashier) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Permission denied")
        );
        return;
      }
      this.$store.commit(SET_SHIFT_CURRENT_ACTION, "end");
      this.closeMenuSide();
      if (this.$route.name !== "cash-calc") {
        this.$router.push({ name: "cash-calc" });
      }
    },
    async printArticleLocation() {
      if (!this.isCashier) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Permission denied")
        );
        return;
      }
      console.log("print for this location");
      console.log(this.user.station);
      this.isModalPrintArticleVisible = true;
      /*       const data = await ArticleService.printReportArticles();
      if (data && !data.error) {
        await this.$store.dispatch("print", data);
      } else {
        this.$store.commit(SET_MESSAGE_MODAL, data);
      } */
    },
    async printArticleStation() {
      if (!this.isCashier) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Permission denied")
        );
        return;
      }
      console.log("print for this station");

      const data = await ArticleService.printReportArticles(true);
      if (data && !data.error) {
        await this.$store.dispatch("print", data);
      } else {
        this.$store.commit(SET_MESSAGE_MODAL, data);
      }
    },
    ...mapMutations([TOGGLE_MENU_SIDE
  //  , START_DAY
  ]),
  },
};
</script>
